import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { reviewDiffStyles as sx } from '../../ReviewModalContent.styles';

type Props = {
	label: string;
};

export const ReviewDeletedItem = ({ label }: Props) => {
	const { t } = useTranslation();

	return (
		<Box sx={sx.changeRow}>
			<Typography component='span' variant='body2' sx={[sx.tag, sx.removedTag]}>
				{t('Removed')}
			</Typography>
			<Typography component='span' variant='body2' sx={sx.removedValue}>
				{label}
			</Typography>
		</Box>
	);
};
